import type { Strings } from './en';

export const STRINGS_AR: Strings = {
  nav: {
    pricing: 'الباقات',
    trust: 'الثقة',
    signin: 'تسجيل الدخول',
    startFree: 'ابدأ مجانًا',
    menu: 'القائمة',
    close: 'إغلاق',
    home: 'برَينوتس',
  },
  home: {
    placeholderTitle: 'برَينوتس',
    placeholderSub: 'هيكلة مبدئية — الواجهة الرئيسية تأتي في المجموعة F.',
  },
};
